import { useEffect } from "react";
import AOS from "aos";
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigationType } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Home } from "./pages/Home";
import { Node } from "./pages/Node";
import { Portfolio } from "./pages/Portfolio";
import { OldHome } from "./pages/OldHome";
import { Dashboard } from "./pages/Dashboard";
import { EmbedTest } from "./pages/EmbedTest";

// Start new pages at the top (e.g. home -> /portfolio), but leave back/forward
// navigation alone so the browser can restore the previous scroll position.
function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    if (navigationType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

export function App() {
  useEffect(() => {
    AOS.init({ easing: "ease-out-quad", duration: 1000 });
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/node" element={<Node />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/projects" element={<Navigate to="/portfolio" replace />} />
        <Route path="/oldhome" element={<OldHome />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/embedtest/:lolz" element={<EmbedTest />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
